// Single source of truth for booking status → color/label, backing the
// --status-* custom properties defined in index.css. Anything that needs an
// inline color (react-big-calendar's eventPropGetter can't take a className)
// should read getStatusColor() rather than hardcoding hex.
export const STATUSES = {
  pending: { cssVar: '--status-pending', label: 'Pending' },
  assigned: { cssVar: '--status-assigned', label: 'Assigned' },
  en_route: { cssVar: '--status-en-route', label: 'En Route' },
  completed: { cssVar: '--status-completed', label: 'Completed' },
  cancelled: { cssVar: '--status-cancelled', label: 'Cancelled' },
};

export const getStatusColor = (status) =>
  `var(${STATUSES[status]?.cssVar || '--gray'})`;

export const getStatusLabel = (status) => STATUSES[status]?.label || status;
